import React from 'react';
import NextLink from 'next/link';
import { isDeeplink } from '../../services/coreUtil';
import {
	paytmOpenDeeplink,
	paytmOpenInBrowser,
	paytmOpenInPushWindow,
} from '../../h5Utils/h5CoreUtil';
import { UrlObject } from 'url';

interface Props extends React.HTMLProps<Element> {
	to: string | UrlObject;
	onClick?: (e: any) => void | undefined;
	children: React.ReactNode;
	className?: string;
	deeplink?: boolean;
	replace?: boolean;
	scroll?: boolean;
	shallow?: boolean;
	passHref?: boolean;
	prefetch?: boolean;
	openExternal?: boolean;
	pushWindowOptions?: any;
	usePushWindow?: boolean;
}

const Link = ({
	to = '',
	onClick = (e) => {},
	children,
	className = '',
	deeplink = false,
	replace,
	scroll = true,
	openExternal,
	pushWindowOptions = {},
	usePushWindow,
}: Props) => {
	const handleDeepLink = () => {
		//onClick();
		paytmOpenDeeplink(to as string);
	};

	const openLinkExternal = () => {
		paytmOpenInBrowser(to as string);
	};

	if (usePushWindow) {
		<a onClick={() => paytmOpenInPushWindow(to as string, pushWindowOptions)} className={className}>
			{children}
		</a>;
	}

	if (openExternal) {
		return (
			<a onClick={openLinkExternal} className={className}>
				{children}
			</a>
		);
	}

	if (deeplink && isDeeplink(to as string)) {
		return (
			<a onClick={handleDeepLink} className={className}>
				{children}
			</a>
		);
	}

	return (
		<NextLink passHref href={to || '/'} replace={replace} scroll={scroll}>
			<a onClick={onClick} className={className}>
				{children}
			</a>
		</NextLink>
	);
};

export default Link;
